import { Button, Typography } from "@mui/material";

export const CustomButton = ({
  variant = "outlined",
  children,
  backgroundColor = "#DB0011",
  borderColor = "#DB0011",
  color = "#fff",
  padding = "0.31rem 3.4rem",
  borderRadius = "0rem",
  textTransform = "none",
  typographyColor = color,
  margin = "auto",
  display = "block",
  disabled = false,
  cursor = "pointer",
  customStyle = {},
  handleClick,
}) => {
  const isTextOnly = typeof children === "string";

  return (
    <Button
      variant={variant}
      onClick={handleClick}
      disabled={disabled}
      sx={{
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        color: color,
        padding: padding,
        borderRadius: borderRadius,
        display: display,
        margin: margin,
        cursor: cursor,
        textTransform: textTransform,
        ":hover": {
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          color: color,
        },
        ...customStyle,
      }}
    >
      {isTextOnly ? (
        <Typography color={typographyColor}>{children}</Typography>
      ) : (
        children
      )}
    </Button>
  );
};
// export const ActionButton = styled(Button)({
//   backgroundColor: "#DB0011",
//   padding: "4px",
//   color: "#fff",
//   width: "30px",
//   height: "30px",
//   minWidth: "unset",
//   minHeight: "unset",
//   borderRadius: "0.15rem",
//   "&:hover": {
//     backgroundColor: "#DB0011",
//     color: "#fff",
//   },
// });

export const ActionButton = ({
  backgroundColor = "#DB0011",
  borderColor="#DB0011",
  padding = "4px",
  color = "#fff",
  width = "30px",
  height = "30px",
  minWidth = "unset",
  minHeight = "unset",
  borderRadius = "0.15rem",
  typographyColor="#000000",
  size="small",
  variant="contained",
  children,
  bordeWidth = 1,
  borderStyle = "solid",
  onClick
}) => {
  const isTextOnly = typeof children === "string";
  return (
    <Button
      onClick={onClick}
      size={size}
      variant={variant}
      sx={{
        backgroundColor: backgroundColor,
        borderColor:borderColor,
        padding: padding,
        color: color,
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        borderRadius: borderRadius,
        borderWidth: bordeWidth,
        borderStyle: borderStyle,
        "&:hover": {
          borderColor:borderColor,
          backgroundColor: backgroundColor,
          color: color,
          borderStyle: borderStyle,
        },
      }}
    >
      {isTextOnly ? (
        <Typography color={typographyColor}>{children}</Typography>
      ) : (
        children
      )}
    </Button>
  );
};
